import env from "../env";

export const SERVER_ENDPOINT = env.API_URL;
export const USPS_SERVER = env.USPS_URL;
export const API_ENDPOINT = `${SERVER_ENDPOINT}/api/`;
export const USPS_API_ENDPOINT = `${USPS_SERVER}/api/dashboard/`;
export const SOCKET_ENDPOINT = SERVER_ENDPOINT;
export const TWILIO_ENDPOINT = "https://www.twilio.com";
export const TRAVELASSIST_ZENDESK_ENDPOINT = "https://travelassist.zendesk.com";
export const ENTRY_ZENDESK_ENDPOINT = "https://entryllc.zendesk.com";

export const ZENDESK_INSTANCES = {
  TRAVELASSIST: "travelassist",
  ENTRY_LLC: "entryllc",
};

export const ZENDESK_URLS_BY_INSTANCE = {
  [ZENDESK_INSTANCES.TRAVELASSIST]: TRAVELASSIST_ZENDESK_ENDPOINT,
  [ZENDESK_INSTANCES.ENTRY_LLC]: ENTRY_ZENDESK_ENDPOINT,
};

const ZENDESK_INSTANCE_LABELS = {
  [ZENDESK_INSTANCES.TRAVELASSIST]: "TravelAssist",
  [ZENDESK_INSTANCES.ENTRY_LLC]: "EntryLLC",
};

export const ZENDESK_INSTANCE_OPTIONS = Object.keys(
  ZENDESK_URLS_BY_INSTANCE,
).map((key) => ({
  key,
  value: key,
  text: ZENDESK_INSTANCE_LABELS[key] || key,
}));

const ZENDESK_TICKET_ENDPOINT = (instanceUrl, zendeskId) =>
  `${instanceUrl}/agent/tickets/${zendeskId}`;

export const TRAVELASSIST_ZENDESK_TICKET_ENDPOINT = (zendeskId) =>
  ZENDESK_TICKET_ENDPOINT(TRAVELASSIST_ZENDESK_ENDPOINT, zendeskId);

export const getZendeskTicketUrl = (zendeskId, zendeskInstance) => {
  const baseUrl = ZENDESK_URLS_BY_INSTANCE[zendeskInstance] || TRAVELASSIST_ZENDESK_ENDPOINT;
  return `${baseUrl}/agent/tickets/${zendeskId}`;
};

export const TWILIO_CALL_ENDPOINT = (callId) =>
  `${TWILIO_ENDPOINT}/console/voice/calls/logs/${callId}`;
